<template>
    <div v-if="getBanner.show && hasSelectedPart" class="banner-shell" :class="{
        '': getBanner.toggle,
        'd-flex justify-content-end': getBanner.toggle
      }">
        <div class="alert alert-danger banner py-2 px-4" role="alert" v-if="!getBanner.toggle">
            <div class="multi-part-selector d-flex justify-content-between align-items-center">
                <div>
                    {{ getBanner.message }}
                </div>
                <div class="d-flex align-items-center">
                    <button 
                        v-if="getBanner.onConfirm" 
                        class="btn btn-outline-light me-2" 
                        @click="handleConfirm"
                    >
                        Alternates
                    </button>
                    <div v-if="shouldDisplayCloseButton" @click="closeModal" class="btn btn-outline-light">
                        X
                    </div>
                    <button v-if="shouldDisplayToggleButton" @click='handleToggle' class="btn btn-outline-light">
                            <font-awesome-icon :icon="['fas', 'chevron-up']" />                  
                    </button>
                </div>
            </div>        
        </div>
        <div v-else>
            <div v-if="shouldDisplayToggleButton" class="alert alert-danger banner banner-toggle py-2 px-4" role="alert">
                <button @click='handleToggle' class="btn btn-outline-light">
                    <font-awesome-icon :icon="['fas', 'chevron-down']" />
                </button>
            </div>
        </div>
        
    </div>
</template>

<script>
import bannerType from "@/data/bannerType.js"

export default {
    name: "TopBannerAlert",
    props: {
        part_selected: {
            type: String,
            default: '',
        },
    },
    computed: {
        getBanner() {
            return this.searchStore.getBanner;
        },
        getBannerType() {
            return bannerType;
        },
        shouldDisplayToggleButton() {
            if (this.getBanner.type == this.getBannerType.PERSISTENT) {
                return false;
            } else if (this.getBanner.type == this.getBannerType.COLLAPSIBLE) {
                return true;
            }
            return false;
        },
        shouldDisplayCloseButton() {
            if (this.getBanner.type == this.getBannerType.PERSISTENT) {
                return false;
            } else if (this.getBanner.type == this.getBannerType.COLLAPSIBLE) {
                return false;
            }
            return true;
        },
        hasSelectedPart() {
            return this.part_selected && this.getBanner.message.includes(this.part_selected);
        },
    },
    methods: {
        closeModal() {
            this.searchStore.setBannerStatus(false);
        },
        handleConfirm() {
            if (this.getBanner.onConfirm) {
                this.getBanner.onConfirm();
            }
            // this.searchStore.setBannerStatus();
        },
        handleToggle() {
            this.searchStore.toggleBanner();
        },
    }
}
</script>

<style scoped>
 .banner-shell {
    width: 100%;
 }

.banner {
    margin: 0 auto;
    background-color: var(--color-brand-primary) !important;
    color: var(--color-text-inverse) !important;
    border-color: var(--color-brand-primary) !important;
}

.banner-toggle {
    width: fit-content;
    padding: 0 !important;
}

.close-button {
    cursor: pointer;
}
</style>
